import React, {Component} from 'react';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from '../PrintPreview';
import TextFieldModal from 'component/element/TextFieldModal'
import PdfStore from 'stores/PdfStore';
import WorkdocStore from 'stores/WorkdocStore';
import './PGA.css'

var NotificationSystem = require('react-notification-system');

const doctitle = [
  {title:'ใบเคลม',doc:'copy_claim2'},
  {title:'ถ่ายรูปเบื้องต้น',doc:'take_init_photo'},
  {title:'ใบขับขี่',doc:'copy_driver_licence'},
  {title:'ออกใบ Job',doc:'issue_job_doc'},
  {title:'ตารางกรมธรรม์',doc:'copy_claim'},
  {title:'จองรถสำรอง',doc:'reserved_backupcar'},
  {title:'สำเนาทะเบียนรถ',doc:'copy_car'}
]
class PrintPGAWorkCoverFileDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false, data:{    
    car:{car_registration_no:'',brand:'',model:''},
    insurer:{insurer_id:'',insurer_name:'',claim_no:''},
    receiving:{entrance_date:'',entrance_name:'',title:'',entrance_name_as:'',tel:'',checking_by:'',openwork_by:''},
    delivering:{delivering_date:''},
    related_detail:{included_doc:this.getEmptyIncludeDoc(),part_from:'',lift_car_from:''
      ,additional_cost:{condition_cost:'',lift_cost:'',advance_lift_cost:'',other_cost:''}},
    doclist:doctitle.map((item,index)=>{
        return {title:item.title,checked:false,doc:item.doc}
      })
    }}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
    this.loadWorkCoverFileDoc()
  }

  getEmptyIncludeDoc(){
    return {
      copy_car:false,
      copy_claim:false,
      copy_driver_licence:false,
      copy_id:false,
      copy_insurance:false,
      copy_other:false,
      copy_company_paper:false,
      copy_claim2:false,
      copy_compromise_agreement:false,
      other_text:''
    }
  }

  loadWorkCoverFileDoc() {
    let {workNo} = this.props
    let that = this
    this.setState({ loading: true })
    PdfStore.loadWorkCoverFileDoc(workNo,function(result) {
      let data = result.data

      if(data.related_detail.additional_cost!==undefined){
        data['related_detail']['additional_cost'] = data.related_detail.additional_cost
      }else{
        data['related_detail']['additional_cost'] = that.state.data.related_detail.additional_cost
      }
      if(data.related_detail.included_doc!==undefined){
        data.doclist = that.state.data.doclist.map((item,index)=>{
          if(item.doc in data.related_detail.included_doc){
            item.checked = data.related_detail.included_doc[item.doc]
          }
          
          return item
        })
      } else {
        data['related_detail']['included_doc'] = that.getEmptyIncludeDoc()
        data = JSON.parse(JSON.stringify(data))
      }
      
      data = Object.assign(that.state.data,data)
      that.setState({data:data})
    })  
  }

  saveParkingcarDoc(data){
    let {workNo} = this.props
    let that = this
    WorkdocStore.saveWorkdocRelated(workNo,'parking_doc',data.related_detail,function(result){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดใบปะหน้าแฟ้ม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      });
    },function(){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึก ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      });
    })
  }

  onAccidentChange(field,value) {
    let {data} = this.state
    
    if (data['car'][field]===value)
      value = ''

    data['car'][field] = value
    this.setState({data:data})
    this.saveInfoAccidentType(value)
  }

  saveInfoAccidentType(value) {
    let {workNo} = this.props
    let postData = {wo:workNo,accident_type:value}
    WorkdocStore.saveInfoAccidentType(postData,(result)=>{
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดใบรับรถ ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },function(){
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึก ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })  
  }

  onCopyPaperChange(index){
    let {data} = this.state
    data.doclist[index].checked = !data.doclist[index].checked
    data.related_detail.included_doc[data.doclist[index].doc] = data.doclist[index].checked
    this.setState({data:data})
    this.saveParkingcarDoc(data)
  }

  onCheckChange(field,value){
    let {data} = this.state
    
    if (data['related_detail'][field]===value)
      value = ''

    data['related_detail'][field] = value
    this.setState({data:data})
    this.saveParkingcarDoc(data)
  }

  onOtherSave(fieldInfo){

    let {data} = this.state
    data['related_detail'].additional_cost[fieldInfo.item.field] = fieldInfo.value

    this.setState({data:data})

    this.saveParkingcarDoc(data)
  }

  onClick(item){
    let fieldInfo = {title:'ใส่ข้อมูล',showClear:true,item:item,value:item.cost }
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} />)
  }

  renderComponentPage() {
    let {car,insurer,receiving,delivering,doclist,related_detail,owner} = this.state.data
    let {part_from,lift_car_from,additional_cost} = related_detail
    let layout_doclist = []
    let col = -1
    let row_doc = []
    doclist.forEach((item,index)=>{
      item = Object.assign({kIndex:index},item)
      col++
      row_doc.push(item)
      if (col===1||doclist.length-1===index) {
        layout_doclist.push(row_doc)
        row_doc = []
        col = -1
      }  
    })
    let vip_member = (receiving.vip_member?receiving.vip_member:'')
    let vip_no = (receiving.vip_no?receiving.vip_no:'')
    return(
      <div className='font-print print-pga-cover'>
        <header style={{position:'relative'}}>
          <span style={{position:'absolute',left:'0',top:'0',display:vip_member?'':'none'}} className='text-left vip-doc'>VIP {vip_no}</span>
          <h2 className="text-right">{'ใบปะหน้าแฟ้ม'}</h2>
        </header>          
        <div className="font-30" style={{marginTop:'10px'}}>   
          <table className="table table-work-cover-file-doc">
            <tbody>
              <tr>
                <td style={{width:'50px'}}>บริษัท</td>
                <td style={{width:'300px'}} className='hr2-b text-center color-work-cover-file-doc'>{insurer.insurer_name}</td>
                <td className='text-center' style={{width:'50px'}}>รหัส</td>
                <td style={{width:'200px',fontSize:'40px'}} className='hr2-b hr2-b-print text-center color-work-cover-file-doc work-no'>{this.props.workNo}</td>
              </tr>  
            </tbody>
          </table>
          <table className="table table-work-cover-file-doc">
            <tbody>      
              <tr>
                <td style={{width:'60px'}} className='w-c1'>ยี่ห้อรถ</td>
                <td style={{width:'200px'}} className='hr2-b hr2-b-print text-center'>{car.brand+'/'+car.model} {car.car_color?'/'+car.car_color:''}</td>
                <td style={{width:'100px'}} className='w-c2 text-center'>ทะเบียนรถ</td>
                <td style={{width:'200px'}} className='hr2-b text-center'>{car.car_registration_no} {car.province}</td>
              </tr>
            </tbody>
          </table>
          <table className="table table-work-cover-file-doc">
            <tbody>      
              <tr>
                <td style={{width:'100px'}} className='w-c1'>ชื่อเจ้าของรถ</td>
                <td style={{width:'150px'}} className='hr2-b hr2-b-print text-center'>{owner?owner.name:''}</td>
                <td style={{width:'100px'}} className='w-c2 text-center'>เลขกรมธรรม์</td>
                <td style={{width:'150px'}} className='hr2-b text-center'>{insurer.insurance_policy_no}</td>
              </tr>
            </tbody>
          </table>    
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'80px'}} className='w-c3'>เลขเคลม</td>
                <td style={{width:'250px'}} className='hr2-b text-center hr2-b-print' >{insurer.claim_no}</td>
                <td style={{width:'80px'}} className='w-c3 text-center'>พนักงาน</td>
                <td style={{width:'250px'}} className='hr2-b text-center hr2-b-print' >{receiving.checking_by}</td>
              </tr>
            </tbody>
          </table>    
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'100px'}} className='w-c3'>ยกรถจาก</td>
                <td className='text-left' colSpan={3}>
                <Checkbox
                    onChange={this.onCheckChange.bind(this,'lift_car_from','garage')}
                    checked={lift_car_from=='garage'}
                    checkboxClass={'icheckbox_square-blue '+(lift_car_from=='garage'?'checkbox-check':'')}
                    increaseArea="20%"
                    label=" อู่"
                  /><Checkbox
                  onChange={this.onCheckChange.bind(this,'lift_car_from','other')}
                  checked={lift_car_from=='other'}
                  checkboxClass={'icheckbox_square-blue '+(lift_car_from=='other'?'checkbox-check':'')}
                  increaseArea="20%"
                  label=" ที่อื่น"
                /></td>
              </tr>
            </tbody>
          </table>             
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'130px'}} className='w-c5'>เบอร์โทรลูกค้า</td>
                <td style={{width:'250px'}} className='hr2-b text-center' >{receiving.tel}</td>
                <td style={{width:'130px'}} className='w-c5 text-center'>เบอร์โทรลูกค้า</td>
                <td style={{width:'250px'}} className='hr2-b text-center' >{receiving.other_tel}</td>
              </tr>
              <tr>
                <td colSpan={4}>
                <Checkbox
                    onChange={this.onCheckChange.bind(this,'part_from','garage')}
                    checked={part_from=='garage'}
                    checkboxClass={'icheckbox_square-blue '+(part_from=='garage'?'checkbox-check':'')}
                    increaseArea="20%"
                    label=" อู่จัดอะไหล่"
                  />
                &nbsp;  
                <Checkbox
                  onChange={this.onCheckChange.bind(this,'part_from','insurer')}
                  checked={part_from=='insurer'}
                  checkboxClass={'icheckbox_square-blue '+(part_from=='insurer'?'checkbox-check':'')}
                  increaseArea="20%"
                  label=" ประกันจัด"
                />
                </td>
              </tr>
            </tbody>
          </table>  
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'50px'}} className='w-c3'>รถเข้า</td>
                <td style={{width:'150px'}} className='hr2-b text-center hr2-b-print'>{receiving.entrance_date}</td>
                <td style={{width:'60px'}} className='w-c3 text-center'>รถออก</td>
                <td style={{width:'150px'}} className='hr2-b text-center hr2-b-print'>{delivering.delivering_date}</td>
                <td style={{width:'60px'}} className='w-c3 text-center'>ตั้งเบิก</td>
                <td style={{width:'150px'}} className='hr2-b text-center hr2-b-print'>{''}</td>
              </tr>
            </tbody>
          </table> 
          <table className="table table-work-cover-file-doc font-20" style={{fontSize:'20px'}}>
            <tbody>    
              <tr>
                <td style={{width:'100px'}} className='w-c3 detail-2'>เสนอราคาวันที่</td>
                <td style={{width:'120px'}} className='hr2-b text-center hr2-b-print'>{''}</td>
                <td style={{width:'130px'}} className='w-c3 detail-2 text-center'>สั่งอะไหล่วันที่(1)</td>
                <td style={{width:'120px'}} className='hr2-b text-center hr2-b-print'>{''}</td>
                <td style={{width:'130px'}} className='w-c3 detail-2 text-center'>สั่งอะไหล่วันที่​(2)</td>
                <td style={{width:'120px'}} className='hr2-b text-center hr2-b-print'>{''}</td>
              </tr>
            </tbody>
          </table> 
        {/* <table className="table table-work-cover-file-doc font-20">
          <tbody>    
            <tr>
              <td style={{width:'80px'}} className='w-c3 detail-2'>อนุมัติอะไหล่วันที่</td>
              <td style={{width:'120px'}} className='hr2-b text-center hr2-b-print'>{''}</td>
              <td style={{width:'70px'}} className='w-c3 detail-2 text-center'>ร้านอะไหล่</td>
              <td style={{width:'120px'}} className='hr2-b text-center hr2-b-print'>{''}</td>
              <td style={{width:'30px'}} className='w-c3 detail-2 text-center'>โทร</td>
              <td style={{width:'120px'}} className='hr2-b text-center hr2-b-print'>{''}</td>
            </tr>
          </tbody>
        </table> */}
        <table className="table table-work-cover-file-doc font-20">
          <tbody>    
            <tr>
              <td style={{width:'80px'}} className='w-c3 detail-2'>อนุมัติอะไหล่วันที่</td>
              <td style={{width:'100px'}} className='hr2-b text-center hr2-b-print'>{''}</td>
              <td style={{width:'100px'}} className='w-c3 detail-2 text-center'>ผู้เปิดเรื่องวันที่</td>
              <td style={{width:'100px'}} className='hr2-b text-center hr2-b-print'>{receiving.contact_date}</td>
              <td style={{width:'50px'}} className='w-c3 detail-2 text-center'>ผู้เปิดเรื่อง</td>
              <td style={{width:'100px'}} className='hr2-b text-center hr2-b-print'>{receiving.openwork_by}</td>
            </tr>
            <tr>
              <td className='text-center detail-2' colSpan={6}>
                <Radio
                        onChange={this.onAccidentChange.bind(this,'accident_type','รถประกัน')}
                        checked={car.accident_type==='รถประกัน'}
                        radioClass={'iradio_square-blue '+(car.accident_type==='รถประกัน'?'radio-check':'')}
                        increaseArea="20%"
                        label=" ประกัน"
                      >
                      </Radio>
                      &nbsp;
                      <Radio
                        onChange={this.onAccidentChange.bind(this,'accident_type','คู่กรณี')}
                        checked={car.accident_type==='คู่กรณี'}
                        radioClass={'iradio_square-blue '+(car.accident_type==='คู่กรณี'?'radio-check':'')}
                        increaseArea="20%"
                        label=" คู่กรณี"
                      >
                      </Radio>
                
              </td>
            </tr>
          </tbody>
        </table>        
          <div style={{width:'100%',display:'flex'}}>
            <div style={{width:'55%'}}>
              <table className="table table-left-work-cover-file-doc">
                <tbody>
                  {layout_doclist.map((ritem,rindex)=>(
                    <tr key={rindex}>
                      {ritem.map((item,index)=>{
                      return(  
                        <td key={rindex+'-'+index} className='w-claims-doc'>
                          <Checkbox
                            onChange={this.onCopyPaperChange.bind(this,item.kIndex)}
                            checked={item.checked}
                            checkboxClass={'icheckbox_square-blue '+(item.checked?'checkbox-check':'')}
                            increaseArea="20%"
                            label={" "+item.title}
                          >
                          </Checkbox>
                        </td>
                      )  
                      })}
                   </tr>
                  ))}                  
                </tbody>
              </table>  
            </div>
            <div style={{width:'45%'}}>
              <table className="table table-right-work-cover-file-doc" style={{border:"2px solid black"}}>
                <tbody>
                  {
                    [{title:'ค่า Excess',field:'excess',cost:''},
                    {title:'ค่ายก',field:'lift_cost',cost:''},
                    {title:'สำรองค่ายก',field:'advance_lift_cost',cost:''},
                    {title:'เพิ่มเติม',field:'diff_payment',cost:''}].map((item,index)=>(
                      <tr key={index}>
                        <td className='font-22'>
                          {item.title}
                        </td>
                        <td>
                          <span onClick={this.onClick.bind(this,item)} style={{position:'relative'}}>
                            {/* ...{(item.field==='excess'||item.field==='diff_payment'?(car[item.field]?car[item.field]:'.....................'):(additional_cost[item.field]!=='')?additional_cost[item.field]:'.....................')}...บาท */}
                            ........................บาท
                            {item.field==='excess'||item.field==='diff_payment'
                            ?
                            (car[item.field]
                              ?
                              <span style={{position:'absolute',top:'0',left:'30px'}}>
                                {car[item.field]}
                              </span>
                              :''
                            )
                            :
                            (additional_cost[item.field]!==''
                              ?
                              <span style={{position:'absolute',top:'0',left:'30px'}}>
                                {additional_cost[item.field]}
                              </span>
                              :''
                            )}
                          </span>
                        </td>
                      </tr>
                    ))
                  }                  
                </tbody>
              </table>
              <table className="table table-work-cover-file-doc">
                <tbody>
                  <tr>
                    <td className='td-appointment-date' style={{fontSize:'22px',width:'150px'}}>วันนัดเข้าซ่อมล่วงหน้า</td>
                    <td className='hr2-b color-work-cover-file-doc'>{receiving.advance_date}</td>
                  </tr>
                  <tr>
                    <td className='td-appointment-date' style={{fontSize:'22px'}}>วันที่นัดรับรถ</td>
                    <td className='hr2-b color-work-cover-file-doc'>{receiving.appointment_date}</td>
                  </tr>              
                </tbody>
              </table>
            </div>
          </div>   
          <div style={{position:'relative'}}>
            {receiving.order_part==='no_order'
            ?      
            <div className='vip-doc' style={{position:'absolute',bottom:'90px',left:'150px'}}>
              ไม่สั่งอะไหล่
            </div>      
            :
            receiving.order_part==='waiting'
            ? 
            <div className='vip-doc' style={{position:'absolute',bottom:'90px',left:'150px'}}>
            รอสั่งอะไหล่
            </div> 
            :
            ''}
            <div>
              <table className="table table-pga-work-cover-file-doc">
                <tbody>
                  <tr>
                    <td className='text-left bd2-t bd2-r td-appointment-date' style={{width:'400px',fontSize:'22px'}}>
                      เพิ่มเติม
                      <br />
                      <br />
                    </td>
                    <td className='text-left bd2-t td-appointment-date' style={{width:'400px',fontSize:'22px'}}>
                      สถานะแจ้งลูกค้า
                      <br />
                      <br />
                    </td>
                  </tr>   
                </tbody>
              </table>
            </div>  
          </div>       
          <TextFieldModal ref='textFieldModal'
            confirmTitle='บันทึก'
            onConfirm={this.onOtherSave.bind(this)}
            />
         <NotificationSystem ref="notificationSystem" />                  
        </div>
      </div>  
    )
  }

  render() {
    let {loading} = this.state
    return(
      <PrintPreview 
        loading={loading} 
        leftBarTitle={'ใบปะหน้าแฟ้ม '+this.props.workNo}>
        {this.renderComponentPage()}
      </PrintPreview>
    )
  }

}  

PrintPGAWorkCoverFileDoc.defaultProps = {
  title: 'ใบปะหน้าแฟ้ม',  
  mode : '1'
}
export default PrintPGAWorkCoverFileDoc;


// WEBPACK FOOTER //
// ./src/view/print/pga/PrintPGAWorkCoverFileDoc.js